import type { FetchPolicy } from 'apollo-client';

import { query, waitForAllReturnWhenError } from '@confluence/query-preloader-tools';

import { TitleContentPropertyQuery, HomepageIdQuery } from './TitleContentPropertyQuery.graphql';
import type {
	HomepageIdQuery as HomepageIdQueryType,
	HomepageIdQueryVariables,
} from './__types__/HomepageIdQuery';

const preloadHomepageId = async (spaceKey: string) => {
	const res = await query<HomepageIdQueryType, HomepageIdQueryVariables>({
		query: HomepageIdQuery,
		variables: {
			spaceKey,
		},
	});

	return res?.data?.space?.homepage?.id;
};

const preloadTitleContentProperty = (contentId: string, fetchPolicy: FetchPolicy = 'cache-first') =>
	query({
		query: TitleContentPropertyQuery,
		variables: {
			contentId,
			status: ['current', 'archived', 'draft'],
		},
		fetchPolicy,
	});

export const preloadPageTitleContentProperties = async ({
	contentId,
	contentIdPromise,
	spaceKey,
	fetchPolicy = 'cache-first',
}: {
	contentId: string;
	contentIdPromise?: Promise<string | undefined>;
	spaceKey: string;
	fetchPolicy?: FetchPolicy;
}) => {
	const promises: Promise<any>[] = [];
	if (!contentId) {
		const homepageIdPromise = contentIdPromise || preloadHomepageId(spaceKey);

		promises.push(
			homepageIdPromise.then((homepageId) =>
				homepageId ? preloadTitleContentProperty(homepageId) : Promise.resolve({}),
			),
		);
	} else {
		promises.push(preloadTitleContentProperty(contentId, fetchPolicy));
	}

	return waitForAllReturnWhenError(promises);
};
